export const environment = {
  production: true,
  version: "1.0.0.25",
  username: "viewer",
  password: "viewer",
};
